// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'
import Present from 'components/ui/icons/Present'

import IconButton from 'components/SideBar/ui/IconButton'
import styles from './index.scss'
import type {
  Announcements_viewer as Viewer,
} from './__generated__/Announcements_viewer.graphql'

type Props = $ReadOnly<{
  viewer: Viewer,
}>

function Announcements({viewer}: Props): Node {
  if (!viewer.hasNewAnnouncements)
    return null

  return (
    <div className={styles.container}>
      <IconButton
        alt={I18n.t('nav.whats_new')}
        href={viewer.routes.announcementsPath}
        target="_blank"
        theme="dark"
      >
        <Present />
      </IconButton>
      <div className={styles.notificationDot} />
    </div>
  )
}

export default (createFragmentContainer(Announcements, {
  viewer: graphql`
    fragment Announcements_viewer on Person {
      hasNewAnnouncements
      
      routes {
        announcementsPath
      }
    }
  `,
}): RelayFragmentContainer<typeof(Announcements)>)
